export const defaultProps = {
  easing: "cubic-bezier(0.5, 0, 0, 1)",
  distance: "30px",
  duration: 1000,
  desktop: true,
  mobile: true,
};

export const targetElements = [
  {
    element: ".section-title",
    animation: {
      delay: 300,
      distance: "0px",
      origin: "bottom",
    },
  },
  {
    element: ".hero-title",
    animation: {
      delay: 500,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".hero-cta",
    animation: {
      delay: 1000,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".about-wrapper__image",
    animation: {
      delay: 600,
      origin: "bottom",
    },
  },
  {
    element: ".about-wrapper__info",
    animation: {
      delay: 1000,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".project-wrapper__text",
    animation: {
      delay: 500,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".project-wrapper__image",
    animation: {
      delay: 1000,
      origin: window.innerWidth > 768 ? "right" : "bottom",
    },
  },
  {
    element: ".experience-block",
    animation: {
      delay: 400,
      origin: "bottom",
    },
  },
  {
    element: ".stats-bar",
    animation: {
      delay: 600,
      origin: "bottom",
    },
  },
  {
    element: ".contact-wrapper",
    animation: {
      delay: 800,
      origin: "bottom",
    },
  },
  {
    element: ".skills-wrapper",
    animation: {
      delay: 800,
      origin: "bottom",
    },
  },
  {
    element: ".project-detail-wrapper__info",
    animation: {
      delay: 600,
      origin: "bottom",
    },
  },
  {
    element: ".project-detail-wrapper__image",
    animation: {
      delay: 800,
      origin: "bottom",
    },
  },
  // Modern CV-style detail pages
  {
    element: ".project-sheet",
    animation: {
      delay: 400,
      origin: "bottom",
    },
  },
  {
    element: ".detail-section",
    animation: {
      delay: 500,
      origin: "bottom",
    },
  },
  {
    element: ".sidebar-box",
    animation: {
      delay: 600,
      origin: window.innerWidth > 768 ? "right" : "bottom",
    },
  },
  {
    element: ".project-media",
    animation: {
      delay: 600,
      origin: "bottom",
    },
  },
];
